<template>
    <div class="col-md-12" style="margin-bottom: 50px;">
        <b-container class="" style="margin-top:50px;">



          <b-tabs justified content-class="mb-5" style="margin-top:20px;">
            <b-container>

<!--              FOR PENDING CLOSURES-->
              <b-tab active>

                <template v-slot:title class="">
                  <h5 class="mt-3" style="font-weight: bold; font-family: roboto; font-size:22px; color:#1D1D1D;">Awaiting Approval</h5>
                </template>

                <p/>

<!--            TAB TITLE HERE-->
                <b-container>
                  <div class="row">
                    <div class="col-md-12 align-items-center d-flex justify-content-left" style="text-align:left; background-color:#6C6C6C;">
                      <p class="mt-3 align-items-center d-flex justify-content-center" style="color:#FFFFFF; font-size:22px; font-weight:600;">Approve UNEA Closure</p>
                    </div>
                  </div>
                </b-container>

<!--            TAB CONTENT STARTS HERE-->

                <b-container>
                  <div class="row mt-3" style="">
                    <div class="col-md-4 align-items-center d-flex justify-content-center" style="background-color:#F4F4F4;">
                      <b-form-group class="col mt-3">
                        <b-row class="">
                          <b-col sm="3" style="text-align:right;" class="mt-1">
                            <label style="font-weight:600; font-size:14px;">Show</label><br>
                          </b-col>
                          <b-col sm="4" class="align-items-center d-flex justify-content-left">
                            <b-form-select
                                style="font-weight:600; font-size:14px; border:none; border-radius: unset;"
                                class=" col-xl-7 ml-1"
                                v-model="perPage"
                                id="perPageSelect"
                                size="sm"
                                :options="pageOptions">
                            </b-form-select>
                          </b-col>
                          <b-col sm="5">
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </div>
                    <div class="col-md-4" style="background-color:#F4F4F4;">
                      <b-form-group class="col mt-3">
                        <b-row class="">
                          <b-col sm="4" style="text-align:right" class="mt-1">
                            <label style="font-weight:600; font-size:14px;">Filter By</label><br>
                          </b-col>
                          <b-col sm="8" class="align-items-center d-flex justify-content-left" style="text-align:left;">
                            <b-form-select style="font-weight:600; font-size:14px; border:none; border-radius: unset;" v-model="filterBy" id="filterBySelect" :options="sortOptions" class=" col-xl-12"></b-form-select>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </div>
                    <div class="col-md-1" style="text-align:right; color:#565754; font-size:14px;">
                      <b-button class="mt-3" size="sm" @click="filterClosures" variant="outline-none" style="font-weight:600; font-size:18px;"><b-icon-search class="h1"></b-icon-search></b-button>
                    </div>
                    <div class="col-md-3" style="background-color:#F4F4F4;">
                      <b-form-group class="col mt-3" style="text-align:left">
                        <b-form-input
                            style="font-weight:600; font-size:14px; border-radius: unset; border:none;"
                            v-on:keyup.enter="filterClosures"
                            v-model="filterValue"
                            type="search"
                            id="filterInput"
                            size="sm"
                            class=""
                            placeholder="Search by column selected"></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                </b-container>
                <b-container>

                  <div class="row mt-3">
                    <b-table class="myTable" hover bordered="" style="background-color:#F4F4F4;" show-empty stacked="md" :items="fetchData" :fields="fields" :sort-by.sync="sortBy"
                             ref="tableClosures"
                             :sort-desc.sync="sortDesc" :small="small" :per-page="perPage" :filter="filter"
                             :current-page="currentPage">
                      <template v-slot:cell(assembly_model.assembly_code)="data">
                        <span style="font-weight:500; font-size:17px;" v-html="data.item.assembly_model.assembly_code"/>
                      </template>

                      <template v-slot:cell(outcome_code)="data">
                        <span style="font-size:17px;" v-html="data.item.outcome_code"/>
                      </template>

                      <template v-slot:cell(outcome_name)="data">
                        <span style="font-size:17px;" v-html="data.item.outcome_name"/>
                      </template>

                      <template v-slot:cell(submitter_name)="data">
                        <span style="font-size:17px;" v-html="data.item.submitter_name"/>
                      </template>

                      <template v-slot:cell(closure_division)="data">
                        <ul>
                          <li class="ml-n4" v-bind:key="division_name" v-for="division_name in data.item.closure_division">
                            <span v-html="division_name.division_name"/>
                          </li>
                        </ul>
                      </template>

                      <template v-slot:cell(actions)="row">

                        <router-link size="sm" :to="{name: 'closureadmin', params:{id: row.item.id}}" variant="primary"
                                     class="mr-1 mt-1 mb-1" style="font-family:roboto; font-size:17px;">
                          <b-icon-eye></b-icon-eye>
                          View
                        </router-link>
                      </template>
                    </b-table>
                  </div>
                </b-container>
                <b-container>
                  <div v-bind:hidden="loadedData" id="loadingGif" style="text-align: center;">
                    <img src="../assets/loading.gif" style="text-align: center; height: 100px;">
                  </div>
                </b-container>
                <b-container>

                  <div class="col-md-12 mt-3">
                    <div class="row justify-content-center">
                      <b-pagination size="md" :total-rows="totalItems" v-model="currentPage"
                                    :per-page="perPage"></b-pagination>
                    </div>
                  </div>
                </b-container>

<!--            TAB CONTENT ENDS HERE-->

              </b-tab>


<!--              FOR APPROVED CLOSURES-->
              <b-tab>

                <template v-slot:title class="">
                  <h5 class="mt-3" style="font-weight: bold; font-family: roboto; font-size:22px; color:#1D1D1D;">Approved Closures</h5>
                </template>

                <!--            TAB CONTENT STARTS HERE-->

                <b-container>
                  <div class="row mt-3" style="">
                    <div class="col-md-4 align-items-center d-flex justify-content-center" style="background-color:#F4F4F4;">
                      <b-form-group class="col mt-3">
                        <b-row class="">
                          <b-col sm="3" style="text-align:right;" class="mt-1">
                            <label style="font-weight:600; font-size:14px;">Show</label><br>
                          </b-col>
                          <b-col sm="4" class="align-items-center d-flex justify-content-left">
                            <b-form-select
                                style="font-weight:600; font-size:14px; border:none; border-radius: unset;"
                                class=" col-xl-7 ml-1"
                                v-model="perPage"
                                id="perPageSelect"
                                size="sm"
                                :options="pageOptions">
                            </b-form-select>
                          </b-col>
                          <b-col sm="5">
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </div>
                    <div class="col-md-4" style="background-color:#F4F4F4;">
                      <b-form-group class="col mt-3">
                        <b-row class="">
                          <b-col sm="4" style="text-align:right" class="mt-1">
                            <label style="font-weight:600; font-size:14px;">Filter By</label><br>
                          </b-col>
                          <b-col sm="8" class="align-items-center d-flex justify-content-left" style="text-align:left;">
                            <b-form-select style="font-weight:600; font-size:14px; border:none; border-radius: unset;" v-model="filterBy" id="filterBySelect" :options="sortOptions" class=" col-xl-12"></b-form-select>
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </div>
                    <div class="col-md-1" style="text-align:right; color:#565754; font-size:14px;">
                      <b-button class="mt-3" size="sm" @click="filterClosures" variant="outline-none" style="font-weight:600; font-size:18px;"><b-icon-search class="h1"></b-icon-search></b-button>
                    </div>
                    <div class="col-md-3" style="background-color:#F4F4F4;">
                      <b-form-group class="col mt-3" style="text-align:left">
                        <b-form-input
                            style="font-weight:600; font-size:14px; border-radius: unset; border:none;"
                            v-on:keyup.enter="filterClosures"
                            v-model="filterValue"
                            type="search"
                            id="filterInput"
                            size="sm"
                            class=""
                            placeholder="Search by column selected"></b-form-input>
                      </b-form-group>
                    </div>
                  </div>
                </b-container>
                <b-container>

                  <div class="row mt-3">
                    <b-table class="myTable" hover bordered="" style="background-color:#F4F4F4;" show-empty stacked="md" :items="fetchData2" :fields="fields" :sort-by.sync="sortBy"
                             ref="tableClosures"
                             :sort-desc.sync="sortDesc" :small="small" :per-page="perPage" :filter="filter"
                             :current-page="currentPage">
                      <template v-slot:cell(assembly_model.assembly_code)="data">
                        <span style="font-weight:500; font-size:17px;" v-html="data.item.assembly_model.assembly_code"/>
                      </template>

                      <template v-slot:cell(outcome_code)="data">
                        <span style="font-size:17px;" v-html="data.item.outcome_code"/>
                      </template>

                      <template v-slot:cell(outcome_name)="data">
                        <span style="font-size:17px;" v-html="data.item.outcome_name"/>
                      </template>

                      <template v-slot:cell(submitter_name)="data">
                        <span style="font-size:17px;" v-html="data.item.submitter_name"/>
                      </template>

                      <template v-slot:cell(closure_division)="data">
                        <ul>
                          <li class="ml-n4" v-bind:key="division_name" v-for="division_name in data.item.closure_division">
                            <span v-html="division_name.division_name"/>
                          </li>
                        </ul>
                      </template>

                      <template v-slot:cell(actions)="row">

                        <router-link size="sm" :to="{name: 'closureadmin', params:{id: row.item.id}}" variant="primary"
                                     class="mr-1 mt-1 mb-1" style="font-family:roboto; font-size:17px;">
                          <b-icon-eye></b-icon-eye>
                          View
                        </router-link>
                      </template>
                    </b-table>
                  </div>
                </b-container>
                <b-container>
                  <div v-bind:hidden="loadedData" id="loadingGif" style="text-align: center;">
                    <img src="../assets/loading.gif" style="text-align: center; height: 100px;">
                  </div>
                </b-container>
                <b-container>

                  <div class="col-md-12 mt-3">
                    <div class="row justify-content-center">
                      <b-pagination size="md" :total-rows="totalItems" v-model="currentPage"
                                    :per-page="perPage"></b-pagination>
                    </div>
                  </div>
                </b-container>

                <!--            TAB CONTENT ENDS HERE-->


              </b-tab>

            </b-container>
          </b-tabs>





        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'Closures',
        components: {},
        data() {
            return {
                loadedData: false,
                apiUrl: process.env.VUE_APP_API_PATH,
                items: [],
                
                filter: null,
                filterValue: '',
                small: false,
                sortBy: '',
                filterBy: 'outcome_name',
                sortDesc: false,
                sortDirection: 'asc',
                pageOptions: [5, 10, 15],
                fields: [
                    {
                        key: 'assembly_model.assembly_code',
                        label: 'ASSEMBLY CODE',
                        searchable: true,
                        //sortable: true,
                        sortDirection: 'desc'
                    },
                    {
                        key: 'outcome_code',
                        label: 'OUTCOME CODE',
                        searchable: true,
                        //sortable: true,
                    },
                    {
                        key: 'outcome_name',
                        label: 'OUTCOME NAME',
                        searchable: true,
                        //sortable: true,
                    },
                    {
                        key: 'submitter_name',
                        label: 'FOCAL POINT',
                        //sortable: true,
                        searchable: true,
                    },
                    {
                        key: 'closure_division',
                        label: 'DIVISION',
                        //sortable: true,
                        searchable: true,
                    },
                    {
                        key: 'actions',
                        label: 'Actions',
                        thStyle: {width: '100px'},
                    }
                ],
                currentPage: 1,
                perPage: 10,
                totalItems: 0,
            }
        },
        computed: {
            sortOptions() {
                // Create an options list from our fields
                return this.fields
                    .filter(f => f.searchable)
                    .map(f => {
                        return {text: f.label, value: f.key}
                    })
            },
            created() {
             this.id = this.$route.params.id;
        },
        },
        methods: {
            filterClosures() {
                this.currentPage = 1;
                this.loadedData = false;
                this.$refs.tableClosures.refresh();
            },
            fetchData(ctx, callback) {
                let url = this.apiUrl;
                let sortD = this.sortDesc ? 'desc' : 'asc';
                fetch(url + '/getclosures?_page=' + `${this.currentPage}&_filterBy=${this.filterBy}&_limit=${this.perPage}&_sortBy=${this.sortBy}&_sortDirection=${sortD}&_filter=${this.filterValue}`)
                    .then(res => res.json())
                    .then(res => {
                        this.totalItems = res["totalItems"];
                        this.loadedData = true;
                        callback(res["data"]);
                    })
                return null
            },
          fetchData2(ctx, callback) {
            let url = this.apiUrl;
            let sortD = this.sortDesc ? 'desc' : 'asc';
            fetch(url + '/getapprovedclosures?_page=' + `${this.currentPage}&_filterBy=${this.filterBy}&_limit=${this.perPage}&_sortBy=${this.sortBy}&_sortDirection=${sortD}&_filter=${this.filterValue}`)
                .then(res => res.json())
                .then(res => {
                  this.totalItems = res["totalItems"];
                  this.loadedData = true;
                  callback(res["data"]);
                })
            return null
          }
        }
    }
</script>

<style>
.myTable thead {
   background-color: #00A5E5!important;
   color: #FFFFFF;
   font-size: 17px;
}
.table-bordered th, .table-bordered td {
    border: 2px solid white;
}
.page-link {
    position: relative;
    display:grid;
    padding: 0.5rem 0.75rem;
    margin-left: -1px;
    line-height: 1.25;
    color: #171717!important;
    background-color:#F4F4F4!important;
    border: 5px solid white!important;
}
.page-item.disabled .page-link {
    color: #6c757d!important;
    pointer-events: none;
    cursor: auto;
    background-color:#F4F4F4!important;
    border-color: white!important;
}
.page-item.active .page-link {
    z-index: 3;
    color: #0062FF!important;
    background-color: #82CAFA!important;
    border-color: white!important;
}
</style>